var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTilesMedium = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.5H9V9H1.5L1.5 1.5ZM0 1.5C0 0.671573 0.671573 0 1.5 0H9C9.82843 0 10.5 0.671573 10.5 1.5V9C10.5 9.82843 9.82843 10.5 9 10.5H1.5C0.671573 10.5 0 9.82843 0 9V1.5ZM15 1.5H22.5V9H15V1.5ZM13.5 1.5C13.5 0.671573 14.1716 0 15 0H22.5C23.3284 0 24 0.671573 24 1.5V9C24 9.82843 23.3284 10.5 22.5 10.5H15C14.1716 10.5 13.5 9.82843 13.5 9V1.5ZM9 15H1.5L1.5 22.5H9V15ZM1.5 13.5C0.671573 13.5 0 14.1716 0 15V22.5C0 23.3284 0.671573 24 1.5 24H9C9.82843 24 10.5 23.3284 10.5 22.5V15C10.5 14.1716 9.82843 13.5 9 13.5H1.5ZM15 15H22.5V22.5H15V15ZM13.5 15C13.5 14.1716 14.1716 13.5 15 13.5H22.5C23.3284 13.5 24 14.1716 24 15V22.5C24 23.3284 23.3284 24 22.5 24H15C14.1716 24 13.5 23.3284 13.5 22.5V15Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTilesMedium);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tiles-medium.16d940eabdfd834763df2d770b84ba22.svg";